import debounce from 'lodash/debounce'
import Vue from 'vue';
let options = {
  inserted(el, binding) {
    let minWidth = binding.value ? binding.value : 0
    const maxWidth = 1100 // 设置1100为最大宽度
    el.style.position = 'relative'
    let hoverable = document.createElement('div')
    hoverable.className = 'resize__panel'
    el.appendChild(hoverable)
    hoverable.addEventListener('mousedown', debounce(function (e) {
        const { right } = el.getBoundingClientRect()
        const adjust = right - e.clientX
        function moveHandler (moveEvent) {
            const fn = () => {
                let { left: pureLeft } = el.getBoundingClientRect()
                pureLeft = Number((pureLeft.toFixed(2)))
                let posx = moveEvent.clientX
                const targetWidth = posx - pureLeft + adjust
                if (targetWidth > minWidth && targetWidth < maxWidth) {
                    el.style.width = `${targetWidth }px`
                }
            }
            /** 无效 */
            // requestAnimationFrame(fn)
            fn()
        }
        document.addEventListener('mousemove',  moveHandler);
        document.addEventListener('mouseup', function upHandler() {
        document.removeEventListener('mousemove', moveHandler)
        document.removeEventListener('mouseup', upHandler)
        })
    }), 1000 / 60)}
}

Vue.directive('resize', options)
